import { ClimateRiskRating, ClimateRiskRatingsByIndex } from '@/api/rest/resources/types/fact';

/**
 * Safely converts a numeric climate risk score to a discrete ClimateRiskRating.
 *
 * Organization-level climate risk values from the API are averaged numeric scores
 * (e.g. 0.8333, 1.666) rather than integer indexes. JavaScript array access with
 * fractional keys returns undefined, which causes downstream string operations to
 * throw and trigger the widget error boundary.
 *
 * This function normalises any numeric input to a valid enum value:
 * - null / undefined / NaN → ClimateRiskRating.not_relevant
 * - Clamp to [0, 5]
 * - Math.ceil to round up to the next discrete risk bucket (consistent with the
 *   backend `annotate_combined_climate_risk` which uses Ceil)
 */
export function safeRiskIndexToRating(value: number | null | undefined): ClimateRiskRating {
  if (value === null || value === undefined || Number.isNaN(value as number)) {
    return ClimateRiskRating.not_relevant;
  }

  const clamped = Math.min(5, Math.max(0, value as number));
  const index = Math.ceil(clamped);
  // eslint-disable-next-line security/detect-object-injection
  return ClimateRiskRatingsByIndex[index] as ClimateRiskRating;
}
